import React, { useState,useEffect } from 'react';
import { SVGs } from '../../constants/Svgs';

interface CustomButtonSortProps {

    text:string
    isClicked? : boolean,
    customStyle? : string,
    customTextStyle? : string,
    onClickProp?: () => void
    Svg? : React.FC

}


const CustomButtonSort : React.FC<CustomButtonSortProps> = ({ isClicked, customStyle, customTextStyle,text,onClickProp,Svg }) => {
    const [isClickedStatus, setIsClickedStatus] =useState(isClicked)
   
    useEffect(() => {
        setIsClickedStatus(isClicked);
    }, [isClicked]); // This useEffect runs whenever 'isClicked' prop changes
    const baseClasses = [];
    if (customStyle) {
        baseClasses.push(customStyle);
    }
    if(customTextStyle) {
        baseClasses.push(customTextStyle)
    }

    return (
        <div className={baseClasses.join(' ')} onClick={onClickProp}>
            {text}
            {Svg && <Svg />}
        </div>
    );

}


export default CustomButtonSort